import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { Quasar } from 'quasar';
import quasarLang from 'quasar/lang/fr';
import VueMaplibreGl from '@indoorequal/vue-maplibre-gl';
import moment from 'moment';
import 'moment/dist/locale/fr';

// Import Quasar css
import 'quasar/src/css/index.sass';
import '@quasar/extras/material-icons/material-icons.css';
import '@quasar/extras/material-symbols-outlined/material-symbols-outlined.css';
import '@quasar/extras/material-symbols-rounded/material-symbols-rounded.css';
import '@quasar/extras/material-symbols-sharp/material-symbols-sharp.css';

import './css/main.scss';

import App from './App.vue';
import router from './router';

const app = createApp(App);

app.use(createPinia());
app.use(router);
app.use(VueMaplibreGl);

app.use(Quasar, {
    lang: quasarLang,
    plugins: {}, // import Quasar plugins and add here
});

moment.locale('fr');

app.mount('#app');
